<div class="page-wrap">
  <div class="order-card-panel">
    <div class="check-circle"><i class="fa-solid fa-check"></i></div>
    <h4 class="thank-you-title">Thank You! Your Order Has Been Placed.</h4>
    <p class="thank-you-sub">You will receive an order confirmation email shortly.</p>
    <div class="row g-3 mb-3">
      <div class="col-6 info-box-spacing">
        <div class="info-box">
          <div class="info-label">Order Number</div>
          <div class="info-value">{{ orderConfirmationData?.code }}</div>
        </div>
      </div>
      <div class="col-6 info-box-spacing">
        <div class="info-box">
          <div class="info-label">Order Date</div>
          <div class="info-value">{{ formatDisplayDate(orderConfirmationData?.creationDate) }}</div>
        </div>
      </div>
      <div class="col-6">
        <div class="info-box">
          <div class="info-label">PO / Job Number</div>
          <div class="info-value">{{ orderConfirmationData?.purchaseOrderNumber }}</div>
        </div>
      </div>
      <div class="col-6">
        <div class="info-box">
          <div class="info-label">Ordered By</div>
          <div class="info-value">{{ orderConfirmationData?.deliveryAddress?.firstName + ' ' +
            orderConfirmationData?.deliveryAddress?.lastName }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="order-card-panel">
    <div class="section-title">Contact Information</div>
    <div class="row mb-2">
      <div class="col-md-4">
        <div class="field-label">Submitters Email</div>
        <div class="field-value">{{ orderConfirmationData?.deliveryAddress?.email }}</div>
      </div>
      <div class="col-md-4">
        <div class="field-label">Phone</div>
        <div class="field-value">{{ getFormattedPhone() }}</div>
      </div>
      <div class="col-md-4">
        <div class="field-label">Company Name</div>
        <div class="field-value">{{ orderConfirmationData?.deliveryAddress?.companyName }}</div>
      </div>
    </div>
  </div>
  <div class="order-card-panel">
    <div class="section-title">Shipping Address</div>
     @if(isLabels){
      <div class="field-value"> <label>Plant Location :</label><label>{{orderConfirmationData?.deliveryAddress?.labelsPlantName}}</label> </div>
      }
    <div class="field-value">
      {{ orderConfirmationData?.deliveryAddress?.line1 }}<br>
      {{ orderConfirmationData?.deliveryAddress?.line2 }}<br>
      {{ orderConfirmationData?.deliveryAddress?.town }}<br>
      {{ orderConfirmationData?.deliveryAddress?.region?.name }}<br>
      {{ orderConfirmationData?.deliveryAddress?.postalCode }}<br>
      {{ orderConfirmationData?.deliveryAddress?.country?.name }}<br>
      Phone: {{ getFormattedPhone() }}
    </div>
  </div>
  @if(!isLabels){
  <div class="order-card-panel">
    <div class="section-title">Shipping Method</div>
    <div class="row mb-2">
      <div class="col-md-4">
        <div class="field-label">Overnight Shipping</div>
        <div class="field-value">{{ orderConfirmationData?.overnightShipping ? 'Yes' : 'No' }}</div>
      </div>
      @if(orderConfirmationData?.overnightShipping){
      <div class="col-md-4">
        <div class="field-label">Overnight Carrier</div>
        <div class="field-value">{{orderConfirmationData?.overnightCarrier}}</div>
      </div>
      <div class="col-md-4">
        <div class="field-label">Account Number</div>
        <div class="field-value">{{orderConfirmationData?.overnightAccountNumber}}</div>
      </div>
      }
    </div>
    @if(orderConfirmationData?.overnightShipping){
    <div class="section-title">Billing Address(for UPS or FedEx)</div>
    <div class="row mb-2">
      <div class="col-md-4">
        <div class="field-label">{{orderConfirmationData?.paymentAddress?.carrierChargerName}}</div>
        <div class="field-label">{{orderConfirmationData?.paymentAddress?.line1}}</div>
        <div class="field-label">{{orderConfirmationData?.paymentAddress?.line2}}</div>
        <div class="field-label">{{orderConfirmationData?.paymentAddress?.city}}</div>
        <div class="field-label">{{orderConfirmationData?.paymentAddress?.region.name}}</div>
        <div class="field-label">{{orderConfirmationData?.paymentAddress?.postalCode}}</div>
        <div class="field-label">{{orderConfirmationData?.paymentAddress?.country.name}}</div>
      </div>
    </div>
    }
  </div>
}

  <div class="order-card-panel">
    <div class="section-title">Products Ordered</div>
    <div class="table-responsive">
      <table class="products-table">
        <thead>
          <tr>
            <th>Product</th>
            <th>Material#</th>
            <th class="qty-cell text-center">Qty</th>
            <th class="text-end">Sales Unit</th>
          </tr>
        </thead>
        <tbody>
          @for (item of orderConfirmationData?.orderEntries; track item.entryNumber) {
          <tr>
            <td data-label="Product">
              <div class="product-cell">
                <div class="product-thumb" aria-hidden="true">
                  @if (resolveImageUrl(item)) {
                    <img [src]="resolveImageUrl(item)" [alt]="item.product?.name || item.product?.code" loading="lazy" />
                  } @else {
                    <cx-media [container]="item.product?.images?.PRIMARY" [format]="'cartIcon'"
                      [alt]="item.product?.name || item.product?.code">
                    </cx-media>
                  }
                </div>
                <div class="product-name">
                  {{ item.product?.name }}
                </div>
              </div>
            </td>
            <td data-label="P/N">{{ item.product?.code }}</td>
            <td data-label="Qty" class="text-center">
              {{ item.quantity }}
              @if (item.carlisleOverlimitComment!=='' && item.carlisleOverlimitComment!==undefined) {
              <div class="qty-note">Reason for quantity overage:<br>{{ item.carlisleOverlimitComment }}</div>
              }
            </td>
            <td data-label="Sales Unit" class="text-end">{{ item.uom }}</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="total-items">Total Items: {{ orderConfirmationData?.orderEntries?.length || 0 }}</div>
  </div>
  <div class="order-card-panel mb-3">
    <div class="section-title">Comments</div>
    <div class="field-value">{{ orderConfirmationData?.deliveryAddress?.note || 'No comments provided.' }}</div>
  </div>

  <div class="text-center">
    <button class="btn btn-primary" (click)="gotoShopping()">Continue Shopping</button>
  </div>
</div>